import React from 'react';
import { FieldDatepicker, FieldInput, FormCol, FormCol12, FormRow } from 'motion-components';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import ProductionExtraTable from './productionExtraTable';
import { useHandleError } from 'shared-pages/services';
import { useRootStore } from 'store';
import {
  FieldSelectCollector,
  FieldSelectSeries,
  FieldSelectWasteReceptionPoint,
  FormFieldCollectionDlg,
} from 'shared-pages/components';
import { isActiveField } from 'shared-pages/common/form-helpfunc';
import { NumberingSeries } from 'shared-pages/shared/constants';

export const FormFields = ({ isNew, updateRecord, refetch, data, id }: any) => {
  const frmkCntx = useFormikContext();
  const { values } = frmkCntx as { values: { collectorId: number; productionLines: any[] } };
  const errors = frmkCntx.errors as any;
  const { authStore, appStore } = useRootStore();

  const { handleGraphqlError } = useHandleError('PiBaseFormFields');
  const { t } = useTranslation();

  function calcUserCanEdit() {
    const canEdit = appStore.isPlatformOwner || isNew;
    const canEditReasoning = '';
    return { canEdit, canEditReasoning };
  }
  const { canEdit, canEditReasoning } = calcUserCanEdit();
  const canEditSeriesSection = !isNew
    ? false
    : appStore.isPlatformOwner ||
      appStore.isCollector ||
      appStore.isCollectorDriver ||
      (appStore.isWasteReceptionPoint && (isNew || data?.wasteOriginTypeId === 2));

  return (
    <div key={data?.id}>
      {/* 1st Row */}
      <FormRow>
        <FieldSelectSeries
          as={FormCol}
          required={true}
          label={t('Σειρά Αρίθμησης Εντύπου')}
          name="seriesId"
          seriestypeId={NumberingSeries.Production}
          disabled={!isNew}
        />
        <FormCol>
          <FieldInput
            disabled={!canEditSeriesSection}
            as={FormCol12}
            label={t('Αριθμός Εντύπου')}
            name="codeNumber"
            type="number"
            placeholder={t('Αφήστε κενό για Αυτόματη Αρίθμηση')}
          />
        </FormCol>
        <FieldInput
          disabled={!canEditSeriesSection}
          as={FormCol}
          label={t('Κωδικός Εντύπου')}
          name="code"
        />
        <FormCol className="col-md">{!isNew && isActiveField(t, canEdit)}</FormCol>
      </FormRow>
      {/* 2nd Row */}
      <FormRow>
        <FieldSelectWasteReceptionPoint
          as={FormCol}
          label={t('Προέλευση')}
          name="fromWastereceptionpointId"
          disabled={!canEdit}
          collectorId={values.collectorId}
        />
        <FieldSelectCollector
          as={FormCol}
          label={t('Συλλέκτης')}
          name="collectorId"
          disabled={!canEdit}
        />
        <FormFieldCollectionDlg
          as={FormCol}
          label={t('Aπό Συλλογή')}
          idFieldName="fromCollectionId"
          nameFieldName="fromCollection.code"
          disabled={!canEdit}
        />
      </FormRow>
      <FormRow>
        <FieldDatepicker
          as={FormCol}
          label={t('Ημερομηνία Παραγωγής')}
          name="productionDate"
          disabled={!canEdit}
        />
        <FieldInput
          as={FormCol}
          label={t('Παρατηρήσεις')}
          name="notes"
          placeholder=""
          disabled={!canEdit}
        />
      </FormRow>
      <div className="mb-5">
        {values?.productionLines && (
          <ProductionExtraTable
            productionId={id}
            refetch={refetch}
            productionLines={values?.productionLines ?? []}
            isNew={isNew}
          />
        )}
        {errors?.productionLines && (
          <div className="text-danger text-sm mt-1">{errors?.productionLines}</div>
        )}
      </div>
      {/* {errors && <div className="text-danger text-sm mt-1">{JSON.stringify(errors)}</div>} */}
    </div>
  );
};
